import resourceConfig from '../config';

export default {
  resources: {
    [resourceConfig.name]: {
      openAction: 'Get KM',
      title: 'Get KM',
      executeAction: 'Submit',
      errorMessage: 'Error',
      successMessage: 'Success',
    }
  }
}